import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { injectIntl } from "react-intl"
import { Redirect } from "react-router-dom"
import SideBar from "../common/layout/sidebar.component.jsx"
import GenericListing from "../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../state/listing/generic-listing/index"
import ContactTabs from "./components/contactTabsComponent"

const ContactListing = () => {
    SideBar.activateMenu("contact")

    if (AppContext.getAccount().attributes.onBoardingStatus === "pending") {
        return <Redirect to={{ pathname: "/" }} />
    }

    return (
        <div>
            <ContactTabs />
            <GenericListing
                objectType={ObjectType.CONTACTS}
                selectableRows
            />
        </div>
    )
}

export default injectIntl(ContactListing)



// WEBPACK FOOTER //
// ./src/customer/List.tsx